import React from 'react';

import { DragIndicatorIcon, Box } from '@gogame/components';

import { DraggableHandlerContainer } from './components';

const DraggableHandler = (props) => (
  <DraggableHandlerContainer {...props}>
    <Box color={'grey.400'}>
      <DragIndicatorIcon sx={{ fontSize: 16 }} />
    </Box>
  </DraggableHandlerContainer>
);

export default DraggableHandler;
